/**
 * @deprecated This file is deprecated. Use the `dateHelpers` class with appropriate methods instead.
 */
import addMinutes from 'date-fns/addMinutes';

const getLocalDate = (date: Date = new Date()): Date => addMinutes(date, -date.getTimezoneOffset());

export default getLocalDate;
